import React, { Component } from "react";
import _ from "lodash";
import { Link } from "gatsby";

class PostTags extends Component {
  render() {
    const { tags } = this.props;
    return (
      <span>
        {tags &&
          tags
            .map(tag => (
              <Link
                key={tag}
                style={{ textDecoration: "none" }}
                to={`/tags/${_.kebabCase(tag)}/`}
              >
                {tag}
              </Link>
            ))
            .reduce((prev, curr) => [prev, ", ", curr])}
      </span>
    );
  }
}

export default PostTags;
